import { useSelector } from 'react-redux'
import PageTitle from '../fragments/PageTitle'
import classes from './Appointments.module.css'
import { useAppointmentsList } from '../../lib/hooks'
// import Pagination from './pagination/Pagination'
import AppointmentsRow from './AppointmentsRow'
import AppointmentsHeader from './AppointmentsHeader'
import AppointmentsFilters from './AppointmentsFilters'
// import { useNavigate, useParams } from 'react-router-dom'
// import Button from '../common/Button'
import Pagination from '../work_queues/pages/pagination/Pagination'

export default function Appointments({ caseIdFromDetails, subscribeRemoteList = true }) {
    // const dispatch = useDispatch()
    // const { caseId } = useParams()


    // const navigate = useNavigate();
    const loading = useSelector(state => state.appointments.loading)
    const snapshot = useSelector(state => state.appointments.snapshotData)
    const patientsList =  useSelector(state => state.appointments.currentpagedata)

    // let caseID = caseId || caseIdFromDetails

    // get the referrals list from the hook 
    useAppointmentsList(caseIdFromDetails ?? null, { enabled: subscribeRemoteList })

    return <>
        <div className={`${classes.header_box} ${caseIdFromDetails ? classes.header_tab : ''}`}>
            <div className='flex-container'>
                <PageTitle isContainer={caseIdFromDetails ? false : true} isInTab={caseIdFromDetails}>
                    Appointments    
                </PageTitle>  
                {/* {caseId && <Button btnStyle={'btn_dark'} click={viewAllAppointments}>View all appointments</Button>} */}
            </div>  
            
            <AppointmentsFilters />
        </div>
        <div className={caseIdFromDetails ? `${classes.body_container} ${classes.body_tab}` : ''}>
            <div
                className={`${classes.content_wrapper} ${caseIdFromDetails ? classes.body_container_inner : ''} ${
                    caseIdFromDetails ? classes.content_wrapper_tab : ''
                }`}
            >
                <table>
                    <AppointmentsHeader isInTab={caseIdFromDetails}/>
                    {loading && snapshot && <tbody className={`${classes.table_body} ${classes.table_body_loading}`}>
                        {snapshot.data.map((item, index) => (
                            <AppointmentsRow key={item.id} data={item} index={index} isInTab={caseIdFromDetails}/>
                        ))}
                    </tbody>}
                    {!loading && patientsList && patientsList.data && <tbody>
                        {patientsList.data.map((item, index) => (
                            <AppointmentsRow key={item.id} data={item} index={index} isInTab={caseIdFromDetails}/>
                        ))}    
                    </tbody>}  
                    {/* {!loading && !patientsList && <tbody>
                        <tr>
                            <td colSpan={tasks_table_header_cells.length}>No items found</td>    
                        </tr> 
                    </tbody>}             */}
                </table>                
            </div>

            {patientsList && patientsList.meta && <div className={`${classes.pagination_container} ${caseIdFromDetails ? classes.in_tab : ''}`}>
                {patientsList  && <Pagination data={patientsList} apiType='appointments' hidePerPage={true} />}
            </div>}
        </div>
    </>
}